import { RootState } from '@store';

const notificationsSelector = (state: RootState) => state.notifications.items;

export { notificationsSelector };
